/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_discount_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the sale price and your savings. Enter the original price and the discount percentage.`)
};

const es_pct_discount_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta el precio de venta y tus ahorros. Introduce el precio original y el porcentaje de descuento.`)
};

const de_pct_discount_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieh den Verkaufspreis und deine Ersparnis. Gib den Originalpreis und den Rabatt-Prozentsatz ein.`)
};

const nl_pct_discount_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk de verkoopprijs en je besparing. Vul de oorspronkelijke prijs en het kortingspercentage in.`)
};

const fr_pct_discount_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez le prix soldé et vos économies. Entrez le prix d'origine et le pourcentage de réduction.`)
};

const it_pct_discount_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri il prezzo scontato e quanto risparmi. Inserisci il prezzo originale e la percentuale di sconto.`)
};

const pt_br2_pct_discount_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja o preço de venda e sua economia. Insira o preço original e a porcentagem de desconto.`)
};

const pt_pct_discount_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja o preço de venda e a sua poupança. Insira o preço original e a percentagem de desconto.`)
};

const ja_pct_discount_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セール価格と節約額を確認。元の価格と割引率を入力してください。`)
};

const zh_pct_discount_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看促销价及节省金额。输入原价和折扣比例。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_discount_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_discount_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_discount_intro", locale)
	if (locale === "en") return en_pct_discount_intro(inputs)
	if (locale === "es") return es_pct_discount_intro(inputs)
	if (locale === "de") return de_pct_discount_intro(inputs)
	if (locale === "nl") return nl_pct_discount_intro(inputs)
	if (locale === "fr") return fr_pct_discount_intro(inputs)
	if (locale === "it") return it_pct_discount_intro(inputs)
	if (locale === "pt-BR") return pt_br2_pct_discount_intro(inputs)
	if (locale === "pt") return pt_pct_discount_intro(inputs)
	if (locale === "ja") return ja_pct_discount_intro(inputs)
	return zh_pct_discount_intro(inputs)
};